import { render, staticRenderFns } from "./Spedizioni.vue?vue&type=template&id=06df04b7"
import script from "./Spedizioni.vue?vue&type=script&lang=js"
export * from "./Spedizioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports